// extracted by mini-css-extract-plugin
module.exports = {"heading":"_3f6B0I5","mediaGridItem":"_35mr_Xu","textWrapper":"_1xjdiuo"};